module.exports = __webpack_public_path__ + "img/img_head3x.40f1d53a.png";